import EditableFormattedMessage from "./EditableFormattedMessage";

export default function AllPersonalityTraitsPages({
  messagesData,
  locale,
  messages,
  updateMessage,
  graph,
  code,
  datePassed,
  keyPage,
  pageNumber
}) {

  function renderAllTraitDetailsList({
  index,
  filterIdx = 2,
  liClassName = "list-counter-marker",
  pageNumber = 1,
  messages,
  updateMessage,
  locale
}) {
  const allTraits = graph?.dataTitles || {};
  
return allTraits.flatMap((trait, idx) => {
  //console.log("allTraits:", allTraits,index,"INDEX: "+idx);
  if (!trait || idx !== index) return [];

  trait = typeof trait === "string"
    ? trait.replace("SCOPEREPORT_", "")
    : trait;

  trait = typeof trait === "string"
    ? trait.replace("EXCITEMENTSEEK", "EXCITEMENT_SEEKING")
    : trait;

  if (typeof filterIdx === "function" ? !filterIdx(idx, trait) : idx !== filterIdx) return [];

  // For each trait, return two list items: one for LOWERTHIRD, one for UPPERTHIRD
  
  return ["LOWERTHIRD", "UPPERTHIRD"].map(extremeKey => {

    // Build the prefix for keys
    const prefix = `SCOPE_REPORT_${trait.toUpperCase().replace(/ /g, "_")}`;
    let percentilePrefix = `${prefix}_PERCENTILE_100`;
    let percentileTitle = `${prefix}_PERCENTILE_100_TITLE`;
    let getDetails = `SCOPE_REPORT_${trait.toUpperCase().replace(/ /g, "_")}_AXIS_HIGH_DESC`;

    let managerDetails = false;

        if (extremeKey === "LOWERTHIRD") {
      percentilePrefix = `${prefix}_PERCENTILE_25`;
      percentileTitle = `${prefix}_PERCENTILE_25_TITLE`;
      getDetails = `SCOPE_REPORT_${trait.toUpperCase().replace(/ /g, "_")}_AXIS_LOW_DESC`;
    }

      if (pageNumber === 5 || pageNumber === 6) {
    const traitKey = trait.toUpperCase().replace(/ /g, "_");
    if (extremeKey === "LOWERTHIRD") {
      getDetails = `SCOPE_REPORT_${traitKey}_DESC_LOW`;
      managerDetails = `SCOPE_REPORT_${traitKey}_MANAGER_DESC_LOW`;
    } else {
      getDetails = `SCOPE_REPORT_${traitKey}_DESC`;
      managerDetails = `SCOPE_REPORT_${traitKey}_MANAGER_DESC`;
    }
  }

    // Build traitDetails object as in your prompt
    let traitDetails;
    if (pageNumber === 6 || pageNumber === 5) {
      traitDetails = {
        title: `${prefix}${extremeKey === "LOWERTHIRD" ? "_AXIS_LOW" : "_AXIS_HIGH"}`,
        description: `${prefix}_DESC`,
        percentile: `${percentileTitle}`,
        strengthsIntro: `${percentilePrefix}_STRENGTHS_INTRO`,
        strengths1: `${percentilePrefix}_STRENGTHS_1`,
        strengths2: `${percentilePrefix}_STRENGTHS_2`,
        strengths3: `${percentilePrefix}_STRENGTHS_3`,
        developmentIntro: `${percentilePrefix}_DEVELOPMENT_INTRO`,
        development1: `${percentilePrefix}_DEVELOPMENT_1`,
        development2: `${percentilePrefix}_DEVELOPMENT_2`,
        development3: `${percentilePrefix}_DEVELOPMENT_3`,
        teamAdvice: `${percentilePrefix}_TEAM_ADVICE`,
        collaboration: `${percentilePrefix}_COLLABORATION`,
        management: `${percentilePrefix}_MANAGEMENT`,
        recognition: `${percentilePrefix}_RECOGNITION`,
        teamKnow: `${percentilePrefix}_TEAM_KNOW`,
        teamKnowLabel: `SCOPE_REPORT_TEAM_KNOW_LABEL`,
        teamAdviceLabel: `SCOPE_REPORT_TEAM_ADVICE_LABEL`,
      };
    } else {
      traitDetails = {
        title: `${prefix}${extremeKey === "LOWERTHIRD" ? "_AXIS_LOW" : "_AXIS_HIGH"}`,
        description: `${prefix}_DESC`,
        percentile: `${percentilePrefix}_TITLE`,
        strengthsIntro: `${percentilePrefix}_STRENGTHS_INTRO`,
        strengths1: `${percentilePrefix}_STRENGTHS_1`,
        strengths2: `${percentilePrefix}_STRENGTHS_2`,
        strengths3: `${percentilePrefix}_STRENGTHS_3`,
        developmentIntro: `${percentilePrefix}_DEVELOPMENT_INTRO`,
        development1: `${percentilePrefix}_DEVELOPMENT_1`,
        development2: `${percentilePrefix}_DEVELOPMENT_2`,
        development3: `${percentilePrefix}_DEVELOPMENT_3`,
        optimize4me: `SCOPE_REPORT_OPTIMIZE_FOR_ME_LABEL`,
        leversMotivation: `SCOPE_REPORT_LEVERS_OF_MOTIVATION_LABEL`,
        optimize: `${percentilePrefix}_OPTIMIZE`,
        motivation: `${percentilePrefix}_MOTIVATION`,
        teamAdvice: `${percentilePrefix}_TEAM_ADVICE`,
        teamAdviceLabel: `SCOPE_REPORT_TEAM_ADVICE_LABEL`,
      };
    }


    return (
      <li key={idx + "_" + extremeKey + "_traits"} className={liClassName}>
        <b className="font-18">
          <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.title} messages={messages} updateMessage={updateMessage} />
        </b>{" "}
        (<EditableFormattedMessage keys={messagesData} locale={locale} msgKey={extremeKey} messages={messages} updateMessage={updateMessage} />)
        <span className="trait-details-box">
          <br />
          <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={getDetails} messages={messages} updateMessage={updateMessage} />
          <br />
          {(pageNumber === 5 || pageNumber === 6) && managerDetails && (
            <div className="trait-details-list-box">
              <b>
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={'SCOPE_REPORT_MANAGER_SUMMARY_LABEL'} messages={messages} updateMessage={updateMessage} />
              </b>{" "}
              <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={managerDetails} messages={messages} updateMessage={updateMessage} />
            </div>
          )}
          <span className="trait-details-list-box">
            <span>
              <span>
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.strengthsIntro} messages={messages} updateMessage={updateMessage} />
              </span>
              <ul className="trait-strengths-list" style={{ margin: 0, paddingLeft: 24 }}>
                {[traitDetails.strengths1, traitDetails.strengths2, traitDetails.strengths3].map((key, idx) => {
                  if (!key || messagesData[key]?.id === undefined) return null;
                  return (
                    <li className="trait-strengths-list-item" key={idx}>
                      <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={key} messages={messages} updateMessage={updateMessage} />
                    </li>
                  );
                })}
              </ul>
            </span>
          </span>
          <span className="trait-details-list-box">
            <span>
              <span>
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.developmentIntro} messages={messages} updateMessage={updateMessage} />
              </span>
              <ul className="trait-development-list" style={{ margin: 0, paddingLeft: 24 }}>
                {[traitDetails.development1, traitDetails.development2, traitDetails.development3].map((key, idx) => {
                  if (!key || messagesData[key]?.id === undefined) return null;
                  return (
                    <li className="trait-development-list-item" key={idx}>
                      <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={key} messages={messages} updateMessage={updateMessage} />
                    </li>
                  );
                })}
              </ul>
            </span>
          </span>
          {pageNumber !== 6 && (
            <span className="trait-details-list-box">
              <span>
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.optimize4me} messages={messages} updateMessage={updateMessage} />
                </b>
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.optimize} messages={messages} updateMessage={updateMessage} />
              </span>
            </span>
          )}
          {pageNumber !== 6 && (
            <span className="trait-details-list-box">
              <span>
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.leversMotivation} messages={messages} updateMessage={updateMessage} />
                </b>
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.motivation} messages={messages} updateMessage={updateMessage} />
              </span>
            </span>
          )}
          {pageNumber === 1 && (
            <span className="trait-details-list-box">
              <span>
                <b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamAdviceLabel} messages={messages} updateMessage={updateMessage} />
                </b>
                <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamAdvice} messages={messages} updateMessage={updateMessage} />
              </span>
            </span>
          )}
          {pageNumber === 5 && (
            <>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={"SCOPE_REPORT_COLLABORATION_LABEL"} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.collaboration} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={"SCOPE_REPORT_MANAGEMENT_LABEL"} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.management} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={"SCOPE_REPORT_RECOGNITION_LABEL"} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.recognition} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamAdviceLabel} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamAdvice} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamKnowLabel} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamKnow} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
            </>
          )}
          {pageNumber === 6 && (
            <>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamAdviceLabel} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamAdvice} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={"SCOPE_REPORT_COLLABORATION_LABEL"} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.collaboration} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={"SCOPE_REPORT_MANAGEMENT_LABEL"} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.management} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={"SCOPE_REPORT_RECOGNITION_LABEL"} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.recognition} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
              <span className="trait-details-list-box">
                <span>
                  <b>
                    <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={"SCOPE_REPORT_ESSENTIAL_FOR_ME_LABEL"} messages={messages} updateMessage={updateMessage} />
                  </b>
                  <EditableFormattedMessage keys={messagesData} locale={locale} msgKey={traitDetails.teamKnow} messages={messages} updateMessage={updateMessage} />
                </span>
              </span>
            </>
          )}
        </span>
      </li>
    );
  });
});
}

  console.log("Rendering AllPersonalityTraitsPages with graph:", graph);
  return (
    <>
      {/* Personality traits page 1 */}
      <div className="PageCharts-chart">
        <div className="header-logo-box">
        </div>
        <div className="report-alt-page">
          <h1>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey={graph.title}
              messages={messages}
              updateMessage={updateMessage}
            />
            <span className="inline font-16">
              {" "}
              -{" "}
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="SCOPE_REPORT_TOP_THREE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </span>
          </h1>
          <ol className="list-counter">
            {renderAllTraitDetailsList({
              index: 0,
              data: graph.data,
              type: graph.type,
              filterIdx: idx => idx <= 1,
              pageNumber,
              messages,
              updateMessage,
              locale,
              renderAllTraitDetailsList
            })}
          </ol>
        </div>
        <div className="pdf-footer">
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey="PAGE"
            messages={messages}
            updateMessage={updateMessage}
          />{" "}
          {keyPage + 2}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="CANDIDATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="TEST_DATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
      {/* Personality traits page 2 */}
      <div className="PageCharts-chart">
        <div className="header-logo-box">
        </div>
        <div className="report-alt-page">
          <h1>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey={graph.title}
              messages={messages}
              updateMessage={updateMessage}
            />
            <span className="inline font-16">
              {" "}
              -{" "}
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="SCOPE_REPORT_TOP_THREE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </span>
          </h1>
          <ol className="list-counter" start="3">
            {renderAllTraitDetailsList({
                index: 1,
                data: graph.data,
                type: graph.type,
                filterIdx: 1,
                pageNumber,
                messages,
                updateMessage,
                locale,
                renderAllTraitDetailsList
            })}
          </ol>
        </div>
        <div className="pdf-footer">
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey="PAGE"
            messages={messages}
            updateMessage={updateMessage}
          />{" "}
          {keyPage + 3}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="CANDIDATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="TEST_DATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
      {/* Personality traits page 3 */}
      <div className="PageCharts-chart">
        <div className="header-logo-box">
        </div>
        <div className="report-alt-page">
          <h1>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey={graph.title}
              messages={messages}
              updateMessage={updateMessage}
            />
            <span className="inline font-16">
              {" "}
              -{" "}
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="SCOPE_REPORT_TOP_THREE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </span>
          </h1>
          <ol className="list-counter" start="5">
            {renderAllTraitDetailsList({
                index: 2,
                data: graph.data,
                type: graph.type,
                filterIdx: 2,
                pageNumber,
                messages,
                updateMessage,
                locale,
                renderAllTraitDetailsList
            })}
          </ol>
        </div>
        <div className="pdf-footer">
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey="PAGE"
            messages={messages}
            updateMessage={updateMessage}
          />{" "}
          {keyPage + 3}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="CANDIDATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="TEST_DATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
      {/* Personality traits page 4 */}
      <div className="PageCharts-chart">
        <div className="header-logo-box">
        </div>
        <div className="report-alt-page">
          <h1>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey={graph.title}
              messages={messages}
              updateMessage={updateMessage}
            />
            <span className="inline font-16">
              {" "}
              -{" "}
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="SCOPE_REPORT_TOP_THREE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </span>
          </h1>
          <ol className="list-counter" start="7">
            {renderAllTraitDetailsList({
                index: 3,
                data: graph.data,
                type: graph.type,
                filterIdx: 3,
                pageNumber,
                messages,
                updateMessage,
                locale,
                renderAllTraitDetailsList
            })}
          </ol>
        </div>
        <div className="pdf-footer">
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey="PAGE"
            messages={messages}
            updateMessage={updateMessage}
          />{" "}
          {keyPage + 3}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="CANDIDATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="TEST_DATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
      {/* Personality traits page 5 */}
      <div className="PageCharts-chart">
        <div className="header-logo-box">
        </div>
        <div className="report-alt-page">
          <h1>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey={graph.title}
              messages={messages}
              updateMessage={updateMessage}
            />
            <span className="inline font-16">
              {" "}
              -{" "}
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="SCOPE_REPORT_TOP_THREE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </span>
          </h1>
          <ol className="list-counter" start="9">
            {renderAllTraitDetailsList({
                index: 4,
                data: graph.data,
                type: graph.type,
                filterIdx: 4,
                pageNumber,
                messages,
                updateMessage,
                locale,
                renderAllTraitDetailsList
            })}
          </ol>
        </div>
        <div className="pdf-footer">
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey="PAGE"
            messages={messages}
            updateMessage={updateMessage}
          />{" "}
          {keyPage + 3}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="CANDIDATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="TEST_DATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
      {/* Personality traits page 6 */}
      <div className="PageCharts-chart">
        <div className="header-logo-box">
        </div>
        <div className="report-alt-page">
          <h1>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey={graph.title}
              messages={messages}
              updateMessage={updateMessage}
            />
            <span className="inline font-16">
              {" "}
              -{" "}
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="SCOPE_REPORT_TOP_THREE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </span>
          </h1>
          <ol className="list-counter" start="11">
            {renderAllTraitDetailsList({
                index: 5,
                data: graph.data,
                type: graph.type,
                filterIdx: 5,
                pageNumber,
                messages,
                updateMessage,
                locale,
                renderAllTraitDetailsList
            })}
          </ol>
        </div>
        <div className="pdf-footer">
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey="PAGE"
            messages={messages}
            updateMessage={updateMessage}
          />{" "}
          {keyPage + 3}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="CANDIDATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="TEST_DATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
      {/* Personality traits page 7 */}
      <div className="PageCharts-chart">
        <div className="header-logo-box">
        </div>
        <div className="report-alt-page">
          <h1>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey={graph.title}
              messages={messages}
              updateMessage={updateMessage}
            />
            <span className="inline font-16">
              {" "}
              -{" "}
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="SCOPE_REPORT_TOP_THREE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </span>
          </h1>
          <ol className="list-counter" start="13">
            {renderAllTraitDetailsList({
                index: 6,
                data: graph.data,
                type: graph.type,
                filterIdx: 6,
                pageNumber,
                messages,
                updateMessage,
                locale,
                renderAllTraitDetailsList
            })}
          </ol>
        </div>
        <div className="pdf-footer">
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey="PAGE"
            messages={messages}
            updateMessage={updateMessage}
          />{" "}
          {keyPage + 3}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="CANDIDATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="TEST_DATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
        {/* Personality traits page 8 */}
      <div className="PageCharts-chart">
        <div className="header-logo-box">
        </div>
        <div className="report-alt-page">
          <h1>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey={graph.title}
              messages={messages}
              updateMessage={updateMessage}
            />
            <span className="inline font-16">
              {" "}
              -{" "}
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="SCOPE_REPORT_TOP_THREE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </span>
          </h1>
          <ol className="list-counter" start="15">
            {renderAllTraitDetailsList({
                index: 7,
                data: graph.data,
                type: graph.type,
                filterIdx: 7,
                pageNumber,
                messages,
                updateMessage,
                locale,
                renderAllTraitDetailsList
            })}
          </ol>
        </div>
        <div className="pdf-footer">
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey="PAGE"
            messages={messages}
            updateMessage={updateMessage}
          />{" "}
          {keyPage + 3}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="CANDIDATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>
          </div>{" "}
          {code}
          <div className="pdf-footer-separator">
            <b>
              <EditableFormattedMessage
                keys={messagesData}
                locale={locale}
                msgKey="TEST_DATE"
                messages={messages}
                updateMessage={updateMessage}
              />
            </b>{" "}
            {datePassed}
          </div>
        </div>
      </div>
    </>
  );
}